import React from 'react'
import '../styles/about.css'
import AboutUs from '../components/AboutUs'

import Footer from "../components/Footer.jsx";

export default function About() {
  return (
    <div className='aboutmain'>


<div className='ab1'>


<div className='llleft'><h1>ABOUT US</h1></div>
<div className='rrright'></div>
  
</div>


<div className='ab2'>

<AboutUs/>

</div>

<Footer/>
    </div>
  )
}
